export default __webpack_public_path__ + "static/media/home-grey.6d365c11.svg";